import * as React from 'react';
import {Link as RouterLink} from 'react-router-dom';

import {Link} from '../link/link';
import type {Size} from '../link/link';

type Props = {
    size?: Size;
    text?: string;
};

export function PlanUpgradeLink(props: Props) {
    const {size = 'normal', text = 'Upgrade your plan'} = props;

    return (
        <>
            {NutClientConfig.instanceOriginatedFromWebFX ? (
                <Link
                    size={size}
                    variant='primary'
                    as='a'
                    href='/setup/billing/redirect-webfx'
                    newTab={true}
                >
                    {text}
                </Link>
            ) : (
                // @ts-expect-error
                <Link size={size} variant='primary' as={RouterLink} to='/setup/billing/sales'>
                    {text}
                </Link>
            )}
        </>
    );
}
